// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__pkswg","bg":"Modal_bg__9YV3l","closeBtn":"Modal_closeBtn__sfhPh","content":"Modal_content__Msx5a"};